import React from 'react';
import { Box, Typography } from '@mui/material';

interface Recommendation {
  count: number;
  label: string;
  color: string;
}

interface RecommendationsSectionProps {
  data: Recommendation[];
}

const RecommendationsSection: React.FC<RecommendationsSectionProps> = ({ data }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: "8px", alignItems: 'end' }}>
      {data.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            backgroundColor: '#FAFBFC',
            padding: '12px',
            borderRadius: '4px',
            height: '40px',
            width: '208px',
          }}
        >
          <Box
            sx={{
              height: '12px',
              border:`3px solid ${item.color}`,
              borderRadius: '8px',
              flexShrink: 0,
            }}
          ></Box>
          <Typography sx={{ fontWeight: 500, color: '#111827', fontSize: '12px' }}>
            {item.count}
          </Typography>
          <Typography sx={{ color: '#6b7280', fontSize: '12px', margin: '-10px' }}>{item.label}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default RecommendationsSection;
